import { useEffect, useState } from "react";

export function useIsOverflowingX() {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (!element) {
      return;
    }

    const observer = new ResizeObserver(() => {
      setIsOverflowing(element.scrollWidth > element.clientWidth);
    });

    observer.observe(element);

    for (const child of element.children) {
      observer.observe(child);
    }

    return () => {
      observer.disconnect();
    };
  }, [element]);

  return { ref: setElement, isOverflowing };
}
